import React, { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './Dedication.styled';
import { StyledInput } from '../../../atoms/Input';
import { CheckboxWithTooltip } from '../../../molecules/CheckboxWithTooltip/CheckboxWithTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Dedication = _ref => {
  let {
    showDedication,
    handleCheckChange,
    handleDedicationChange
  } = _ref;
  const {
    t
  } = useTranslation('blocks.donation');
  const [checked, setChecked] = useState(showDedication);
  const checkboxWithTooltipId = useId();
  const inputId = useId();
  const handleInputChange = e => {
    const newValue = e.target.value.trim();
    handleDedicationChange(newValue);
  };
  return /*#__PURE__*/_jsxs(Styled.Container, {
    children: [/*#__PURE__*/_jsx(CheckboxWithTooltip, {
      id: checkboxWithTooltipId,
      label: t('Dedication.label', 'Dedicate my donation'),
      tooltipText: t('Dedication.tooltip', "You'll be able to add a note and complete your dedication later"),
      tooltipProps: {
        placement: 'top'
      },
      checkboxProps: {
        onChange: e => {
          handleCheckChange(e.target.checked);
          setChecked(e.target.checked);
        }
      }
    }), checked && /*#__PURE__*/_jsx(Styled.Input, {
      children: /*#__PURE__*/_jsx(StyledInput, {
        id: inputId,
        "aria-label": t('Dedication.inputAriaLabel', 'Who do you want to dedicate this donation to?'),
        placeholder: t('Dedication.placeholder', 'Honoree Name'),
        onChange: handleInputChange,
        autoFocus: true,
        maxLength: 255
      })
    })]
  });
};